import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetOffersByRequestId } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

type Props = {
    id: string;
    requestId?: string;
};

export const useOffersByRequestId = ({ id, requestId }: Props) => {
    return useAggregateQuery({
        acl: { loanRequestId: id },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getOffersByRequestId,
        schema: schemaLoanRequestResolver_GetOffersByRequestId,
        searchParams: { id, requestId },
    });
};
